import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import { path } from 'ramda'
import VideoItem from './VideoItem'
import VideoActions from 'Redux/VideoRedux'
import VideoUpload from 'Components/VideoUpload/VideoUpload'
import styles from './ListStyles'

class VideosList extends Component {
  componentDidMount () {
    this.requestVideos()
  }

  componentDidUpdate (prevProps) {
    if (this.props.match !== prevProps.match ||
        this.props.updateData !== prevProps.updateData) {
      this.requestVideos()
    }
  }

  requestVideos = () => {
    const projectId = path(['params', 'projectId'], this.props.match)
    this.props.videosListRequest(projectId)
  }

  onDrop = (baseVideo, versionedVideo) => {
    const isParent = versionedVideo.videosCount !== 0
    if(!isParent) {
      this.props.videosUpdateRequest(versionedVideo.id, {
        parentId: baseVideo.id
      })
    }

    this.props.videosSetDragVideoId(null)
  }

  render () {
    return (
      <div className={styles.videoItemsWrap}>
        {this.props.videos.map(video => {
          return <VideoItem
            key={video.id}
            video={video}
            history={this.props.history}
            onDrop={this.onDrop}
          />
        })}
        <VideoUpload match={this.props.match} />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
  videos: state.videos.listData,
  updateData: state.videos.updateData,
  activeProject: state.selections.activeProject
})

const mapDispatchToProps = (dispatch) => ({
  videosListRequest: (projectId) =>
    dispatch(VideoActions.videosListRequest(projectId)),
  videosUpdateRequest: (id, params) =>
    dispatch(VideoActions.videosUpdateRequest(id, params)),
  videosSetDragVideoId: videoId =>
    dispatch(VideoActions.videosSetDragVideoId(videoId))
})

export default DragDropContext(HTML5Backend)(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VideosList)))



// WEBPACK FOOTER //
// ./src/Pages/Videos/List.js